<template>
  <div class="is-marginless is-paddingless section section-details" v-if="client">
    <div class="pdt-20px">
      <user-warning-message
        :users="[{
          id: client.commercialId,
          msg: 'utilisateur.warning.commercialArchive'
        }]"/>
      <div class="columns">
        <div class=" column is-10">
          <div class="card" id="generalInformations">
            <header class="header-card">
              <p>
                {{ $t('detailClient.generalTitle.generalInformations')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <figure class="column is-2">
                  <app-logo readOnly class="is-pulled-left"
                    :elementId="client.id"
                    :libelleElement="$t('detailClient.libelleClientForLogo',
                    { nomCommercial: client.nomCommercial })">
                  </app-logo>
                </figure>
                <div class="column is-6">
                  <span class="has-text-default is-italic">N° {{client.code}}</span><br>
                  <b-field class="is-marginless">
                    <div class="title is-4 is-marginless">
                      {{client.nomCommercial}}
                      <b-tooltip :label="$t('detailClient.generalTitle.prospect')"
                                 class="mgl-10px"
                                 v-if="client.prospect"
                                 type="is-warning"
                                 position="is-right">
                        <b-icon icon="account-search" class="is-cursor-pointer mgr-5px"
                                size="is-small"
                                type="is-warning">
                        </b-icon>
                      </b-tooltip>
                    </div>
                    <b-tag class="has-background-subMenu mgl-10px has-text-white"
                           v-if="client.typologie !== typoAucun">
                      {{ $t(getTypologieClient) }}
                    </b-tag>
                    <b-tag v-if="client.archive"
                      type="has-background-subMenu"
                      class="has-text-white mgl-5px">
                      {{$t('detailClient.archive')}}
                    </b-tag>
                    <div class="mgl-5px">
                      <tag-list
                        v-for="(tagsRow, index) in chunkArray(clientTags, 3)"
                        :key="index"
                        :listes="tagsRow"
                        class="mgb-0"/>
                    </div>
                  </b-field>
                  <div class="has-text-default">{{client.nomJuridique}}</div>
                  <b-field v-if="nomGroupeEnseigne">
                    <div class="has-text-default is-italic">
                      {{ nomGroupeEnseigne }}
                    </div>
                    <router-link-blank v-if="client.tiersParentId"
                                       :to="{ name: 'c.bodac.clients/contacts-client',
                                      params: { id: client.tiersParentId } }" icon="open-in-new"
                                       classMessage="mgl-10px"
                                       typeIcon="is-primary" sizeIcon="is-small">
                    </router-link-blank>
                  </b-field>
                  <div class="has-text-default"
                    v-if="moduleStockTiersActive && client.lieuStockage">
                    {{$t('detailClient.informations.lieuStockage')}}
                    <b-icon icon="warehouse" class="mgr-5px"
                      size="is-small"
                      type="is-warning">
                    </b-icon>
                  </div>
                  <div  class="has-text-default">
                    <span class="is-italic"> {{$t('detailClient.divers.tiersMarque')}} </span>
                    <span class="has-text-weight-semibold"> {{ getMarques() }} </span>
                  </div>
                </div>
                <gmap-map class="column is-4 is-height-250px"
                          :center="center"
                          :zoom="client.adressePostale.longitude !== null
                          && client.adressePostale.latitude !== null
                ? constantes.ZOOM_DEFAULT_EMPLACEMENT : constantes.ZOOM_DEFAULT_SANS_MARKER">
                  <div  v-if="client.adressePostale.longitude
                  && client.adressePostale.latitude">
                    <gmap-marker :key="m.num"
                                 v-for="(m) in markers"
                                 :position="m.position"
                                 :draggable="false"
                                 :icon="iconMarker">
                    </gmap-marker>
                  </div>
                </gmap-map>
              </div>
              <div class="columns">
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.generalTitle.contactInformations')}}
                  </p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.phone')}}</p>
                   <p class="has-text-default has-text-weight-semibold">{{client.telephone}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.cellPhone')}}</p>
                  <p class="has-text-default has-text-weight-semibold">{{client.portable}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.email')}}</p>
                  <p class="lien has-text-weight-semibold">{{client.email}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.webSite')}}</p>
                  <a class="lien has-text-weight-semibold">{{client.siteWeb}}</a>
                  <br>
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.generalTitle.businessInformations')}}
                  </p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.profil')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ client.profilTiers ? client.profilTiers.libelle : '' }}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.trade')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ commercial }}</p>
                  <br>
                </div>
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.generalTitle.administrativeInformations')}}
                  </p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.siret')}}</p>
                  <p class="has-text-default has-text-weight-semibold">{{client.siret}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.ape')}}</p>
                  <p class="has-text-default has-text-weight-semibold">{{client.ape}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.intracommunityTva')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{client.tvaIntracommunautaire}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.activity')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{secteurActivite}}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.factureParMail')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ client.factureParMail ? $t('general.oui') : $t('general.non') }}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.applicationTva')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ getApplicationTvaTrad(client.applicationTva) }}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.prospect')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ client.prospect ? $t('general.oui') : $t('general.non') }}</p>
                  <br>
                  <p class="has-text-default is-italic">
                    {{$t('detailClient.informations.domTom')}}</p>
                  <p class="has-text-default has-text-weight-semibold">
                    {{ client.domTom ? $t('general.oui') : $t('general.non') }}</p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold"
                    v-if="aAdressePostale || aAdresseFacturation">
                    {{ $t('detailClient.generalTitle.address')}}
                  </p>
                  <br>
                  <p class="has-text-default is-italic" v-if="aAdressePostale">
                    {{$t('detailClient.informations.postalAddress')}}</p>
                  <p class="has-text-default has-text-weight-semibold" v-if="aAdressePostale">
                    {{client.adressePostale.intitule1}}
                    {{client.adressePostale.intitule2}}
                    {{client.adressePostale.intitule3}}
                    <br v-if="client.adressePostale.intitule1">
                    {{client.adressePostale.adresse1}}
                    {{client.adressePostale.adresse2}}
                    {{client.adressePostale.adresse3}}
                    <br v-if="client.adressePostale.adresse1">
                    {{client.adressePostale.codePostal}}
                    {{client.adressePostale.ville}}
                    {{client.adressePostale.pays}}
                    <span v-if="client.adressePostale.departement">
                      <br/>{{ $t('detailClient.informations.dept') }} : </span>
                    {{ client.adressePostale.departement }}
                  </p>
                  <br>
                  <p class="has-text-default is-italic" v-if="aAdresseFacturation">
                    {{$t('detailClient.informations.billingAddress')}}</p>
                  <div v-if="aAdresseFacturation">
                    <p class="has-text-default has-text-weight-semibold"
                      v-if="client.adresseFacturationDifferente">
                      {{client.adresseFacturation.intitule1}}
                      {{client.adresseFacturation.intitule2}}
                      {{client.adresseFacturation.intitule3}}
                      <br v-if="client.adresseFacturation.intitule1">
                      {{client.adresseFacturation.adresse1}}
                      {{client.adresseFacturation.adresse2}}
                      {{client.adresseFacturation.adresse3}}
                      <br v-if="client.adresseFacturation.adresse1">
                      {{client.adresseFacturation.codePostal}}
                      {{client.adresseFacturation.ville}}
                      {{client.adresseFacturation.pays}}
                    </p>
                    <p class="has-text-default has-text-weight-semibold"
                      v-else>
                      {{client.adressePostale.intitule1}}
                      {{client.adressePostale.intitule2}}
                      {{client.adressePostale.intitule3}}
                      <br v-if="client.adressePostale.intitule1">
                      {{client.adressePostale.adresse1}}
                      {{client.adressePostale.adresse2}}
                      {{client.adressePostale.adresse3}}
                      <br v-if="client.adressePostale.adresse1">
                      {{client.adressePostale.codePostal}}
                      {{client.adressePostale.ville}}
                      {{client.adressePostale.pays}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="card" id="contacts">
            <header class="header-card">
              <p>
                {{ $t('detailClient.generalTitle.contacts')}}
              </p>
            </header>
            <contacts :tier="client"></contacts>
          </div>
          <br>
          <div v-if="modulePortailClientActive" class="card" id="contactsPortail">
            <header class="header-card">
              <p>
                {{ $t('detailClient.generalTitle.contactsPortail')}}
              </p>
            </header>
            <contacts-portail :tiers="client"></contacts-portail>
          </div>
          <br>
          <div class="card" id="bankDetails">
            <header class="header-card">
              <p>
                {{ $t('detailClient.generalTitle.bankDetails')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <div class="column">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.informations.rib.bankTitle')}}
                  </p>
                  <br>
                  <p class="columns is-paddingless is-marginless">
                    <span class="column is-6 is-marginless is-paddingless">
                      <span class="has-text-default is-italic">
                        {{$t('detailClient.informations.rib.bank')}} : </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{client.rib.banque}}</span>
                    </span>
                    <span class="column is-6 is-marginless is-paddingless">
                      <span class="has-text-default is-italic">
                        {{$t('detailClient.informations.rib.holder')}} : </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{client.rib.titulaire}}</span>
                    </span>
                  </p>
                  <br>
                  <p>
                    <span class="has-text-default is-italic">
                      {{$t('detailClient.informations.rib.iban')}} : </span>
                    <span class="has-text-default has-text-weight-semibold">
                      {{iban}}</span></p>
                  <br>
                  <p>
                    <span class="has-text-default is-italic">
                      {{$t('detailClient.informations.rib.bic')}} : </span>
                    <span class="has-text-default has-text-weight-semibold">
                      {{client.rib.bic}}</span></p>
                </div>
                <div class="column">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.generalTitle.regulationsInformations')}}
                  </p>
                  <br>
                  <p>
                    <span class="has-text-default is-italic">
                      {{$t('detailClient.informations.settlementMode')}} : </span>
                    <span class="has-text-default has-text-weight-semibold"
                      v-if="client.modeReglement">
                      {{client.modeReglement.libelle}}</span></p>
                  <br>
                  <p>
                    <span class="has-text-default is-italic">
                      {{$t('detailClient.informations.settlementPeriod')}} : </span>
                    <span class="has-text-default has-text-weight-semibold"
                      v-if="client.delaiReglement">
                      {{client.delaiReglement.libelle}}</span>
                  </p>
                  <br/>
                  <p v-if="client.delaiReglement && client.delaiReglement.estPersonnalisable">
                      <span class="has-text-default is-italic"
                        v-if="client.delaiReglementDetail.nombreJourDecalage">
                        {{$t('detailClient.informations.dayNumber')}} :
                      </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{client.delaiReglementDetail.nombreJourDecalage}}
                      </span>
                      <span class="has-text-default has-text-weight-semibold"
                        v-if="client.delaiReglementDetail.finDeMois">
                        - {{$t('detailClient.informations.endMonth')}}
                      </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{client.delaiReglementDetail.jourFinDeMois}}
                      </span>
                  </p>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="card height-100" id="accountingInformations">
                <header class="header-card">
                  <p>
                    {{ $t('detailClient.generalTitle.accountingInformations')}}
                  </p>
                </header>
                <div class="card-content">
                  <p class="columns is-multiline">
                      <span class="column is-12">
                        <span class="has-text-default is-italic">
                          {{$t('detailClient.informations.accountingAccount')}} :
                        </span>
                        <span class="has-text-default has-text-weight-semibold">
                          {{ client.compteComptable }}
                        </span>
                      </span>
                    <span class="column is-12">
                      <span class="has-text-default is-italic">
                        {{$t('detailClient.informations.typeMandatSepa')}} :
                      </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{ $t(libelleTypeMandat) }}
                      </span>
                    </span>
                    <span class="column is-12">
                      <span class="has-text-default is-italic">
                        {{$t('detailClient.informations.referenceUniqueMandat')}} :
                      </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{client.referenceUniqueMandat}}
                      </span>
                    </span>
                    <span class="column is-12">
                      <span class="has-text-default is-italic">
                        {{$t('detailClient.informations.dateSignatureMandatSepa')}} :
                      </span>
                      <span class="has-text-default has-text-weight-semibold">
                        {{ client.dateSignatureMandatSepa | formatDate}}
                      </span>
                    </span>
                    <span v-if="moduleFactorActive" class="column is-12 columns">
                      <span class="has-text-default is-italic column is-narrow pdr-0">
                        {{$t('detailClient.informations.factor')}} :
                      </span>
                      <router-link-blank v-if="client.factorId"
                        :to="{ name: 'c.bodac.factor',
                          params: { id: client.factorId,
                            sousTypeFrom: tiersSousTypeFactor } }"
                        :message="client.factor.nomCommercial"
                        class="lien column">
                      </router-link-blank>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <honoraire :tiers="client" :isEdit="false"></honoraire>
            </div>
            <div class="column is-6" v-if="societeActive.roles.length > 1">
              <div class="card" id="roleVente">
                <header class="header-card">
                  <p>
                    {{ $t('detailClient.generalTitle.roleVendeur')}}
                  </p>
                </header>
                <div class="card-content">
                  <p>
                <span class="has-text-default is-italic">
                      {{$t('detailClient.informations.role')}} : </span>
                    <span class="has-text-default has-text-weight-semibold">
                      {{ $t(getLibelleRole) }}</span></p>
                </div>
              </div>
            </div>
            <div class="column" :class="societeActive.roles.length === 1 ? 'is-12' : 'is-6'">
              <info-commande :tiers="client"></info-commande>
            </div>
          </div>
          <div class="card" id="comments">
            <header class="header-card">
              <p>
                {{ $t('detailClient.generalTitle.comments')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns is-multiline">
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.informations.commentsOrderForm')}}
                  </p>
                  <br>
                  <p class="has-text-default">{{client.commentairesBonDeCommandes}}</p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.informations.commentsBilling')}}
                  </p>
                  <br>
                  <p class="has-text-default">{{client.commentairesFacturation}}</p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.informations.commentsIntern')}}
                  </p>
                  <br>
                  <p class="has-text-default">{{client.commentairesInternes}}</p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('detailClient.informations.instructionsDemat')}}
                  </p>
                  <br>
                  <p class="has-text-default">{{client.instructionDematerialisation}}</p>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="card height-100" id="divers">
                <header class="header-card">
                  <p>
                    {{ $t('detailClient.generalTitle.divers')}}
                  </p>
                </header>
                <div class="card-content">
                  <app-info-divers :client="client"></app-info-divers>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <info-periode-budgetaire :client="client">
              </info-periode-budgetaire>
            </div>
          </div>
          <div class="card" id="attachments">
            <header class="header-card">
              <p>
                {{ $t('piecesJointes.attachments')}}
              </p>
            </header>
            <div class="card-content">
              <app-pieces-jointes readOnly
                                  deletable
                                  autoSave
                                  :checkPermissions=checkPermissions(permsTiers.maj)
              />
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="sticky-20px">
            <div class="card">
              <div class="card-content">
                <p class="has-text-grey center">
                  {{this.$t('detailClient.enCoursClienAu')}}{{new Date() | formatDate}}
                </p>
                <div class="content has-text-centered is-size-3 has-text-weight-bold mgt-10px">
                  <div :class="{'has-text-danger': soldeClientInfo < 0}" v-if="numberMouvement > 0">
                    {{ soldeClientInfo | formatDevise}}
                  </div>
                  <div v-else class="is-size-5">
                    {{ this.$t('detailClient.aucunMouvement') }}
                  </div>
                </div>
              </div>
              <footer class="card-footer has-background-addOrEdit">
                <router-link :to="{name: 'c.bodac.clients/contacts-enCours' }"
                             :class="{'text-access-no-permission':
                                   !checkPermissions(permsTiers.lecture)}"
                            class="is-size-5 card-footer-item has-text-white">
                  {{ this.$t('detailClient.voirEncoursClient') }}
                </router-link>
              </footer>
            </div>
            <br>
            <dots-menu :steps="steps">
            </dots-menu>
            <information-create-update-user :data="client"
            ></information-create-update-user>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getAllByTiers } from '@/api/contacts/index';
import * as clientConf from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import DotsMenu from '@/components/general/dotsMenu';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import { TIERS } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import appInfoDivers from '@/components/clients/clients/detailClient/infoDivers';
import { SOCIETE_ROLE_VENTE } from '@/configuration/societe/societe';
import markersGetter from '@/services/general/map/markersGetter';
import {
  ZOOM_DEFAULT_EMPLACEMENT,
  ZOOM_DEFAULT_SANS_MARKER,
  COULEUR_PUCE_DEFAULT,
  CENTER_DEFAULT,
} from '@/configuration/general/carteConf';
import centerMapGetter from '@/services/general/map/centerMapGetter';
import getDataUrl from '@/services/general/map/urlToIcon';
import { HEIGHT_LOGO_ICON, WIDTH_LOGO_ICON } from '@/configuration/general/iconMarkerConf';
import infoCommande from '@/components/commun/tiers/detailTiers/infoCommande';
import honoraire from '@/components/clients/clients/honoraire/honoraire';
import infoPeriodeBudgetaire from '@/components/clients/clients/detailClient/infoPeriodeBudgetaire';
import getLogoClient from '@/services/tiers/getLogoClient';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import ibanFormater from '@/services/general/ibanFormater';
import contacts from '@/components/tiers/contacts/contacts';
import contactsPortail from '@/components/tiers/contacts/contactsPortail';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import tagList from '@/components/general/tagList';

const Clients = createNamespacedHelpers('clients');
const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'detail-client',
  props: {
    tiersId: String,
    tiersInformation: Object,
    soldeClientInfo: Number,
    numberMouvement: Number,
  },
  components: {
    contacts,
    contactsPortail,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    DotsMenu: DotsMenu,
    routerLinkBlank,
    appInfoDivers,
    infoCommande,
    honoraire,
    infoPeriodeBudgetaire,
    InformationCreateUpdateUser,
    userWarningMessage,
    tagList,
  },
  data() {
    return {
      permsTiers: TIERS,
      client: false,
      secteurActivite: '',
      utilisateurs: [],
      typoAucun: clientConf.TYPOLOGIE_AUCUN,
      typoPointeVente: clientConf.TYPOLOGIE_POINT_DE_VENTE,
      typoEnseigne: clientConf.TYPOLOGIE_ENSEIGNE,
      tiersSousTypeFactor: clientConf.TIERS_SOUS_TYPE_FACTOR,
      logo: null,
      iconMarker: null,
      constantes: {
        ZOOM_DEFAULT_EMPLACEMENT,
        ZOOM_DEFAULT_SANS_MARKER,
      },
      steps: [
        {
          name: this.$i18n.t('detailClient.generalTitle.generalInformations'),
          ref: '#generalInformations',
          active: true,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.contacts'),
          ref: '#contacts',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.bankDetails'),
          ref: '#bankDetails',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.accountingInformations'),
          ref: '#accountingInformations',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.honoraire'),
          ref: '#honoraire',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.roleVendeur'),
          ref: '#roleVente',
          active: false,
        },
        {
          name: this.$i18n.t('detailTiers.steps.commande'),
          ref: '#infoCommande',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.comments'),
          ref: '#comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.divers'),
          ref: '#divers',
          active: false,
        },
        {
          name: this.$i18n.t('detailClient.generalTitle.periodeBudgetaire'),
          ref: '#periodeBudgetaire',
          active: false,
        },
        {
          name: this.$i18n.t('piecesJointes.attachments'),
          ref: '#attachments',
          active: false,
        },
      ],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    iban() {
      return ibanFormater(this.client.rib.iban);
    },
    markers() {
      return markersGetter(this.client.adressePostale, COULEUR_PUCE_DEFAULT);
    },
    modulePortailClientActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleFactorActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
    center() {
      if (this.client.adressePostale.longitude !== null
        && this.client.adressePostale.latitude !== null) {
        return centerMapGetter(this.client.adressePostale, this.markers);
      }
      return centerMapGetter(CENTER_DEFAULT, []);
    },
    secteursActivites() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.secteurActivite);
    },
    commercial() {
      if (!this.client.commercialId) return '';
      const commercial = this.utilisateurs.find(u => u.id === this.client.commercialId);
      if (!commercial) return '';
      return commercial.decorator.nomPrenom;
    },
    getTypologieClient() {
      const typologie = clientConf.LISTE_TYPOLOGIE.find((typo) => {
        return typo.code === this.client.typologie;
      });
      return typologie ? typologie.libelle : '';
    },
    getLibelleRole() {
      const role = SOCIETE_ROLE_VENTE.find((el) => { return el.code === this.client.role; });
      return role ? role.libelle : '';
    },
    nomGroupeEnseigne() {
      let nom = '';
      if (this.client.typologie === this.typoPointeVente && this.client.tiersParent) {
        if (this.client.tiersParent.tiersParent) {
          nom = this.$i18n.t('detailClient.informations.groupe', { groupe: this.client.tiersParent.tiersParent.nomCommercial }) + ' - ';
        }
        nom += this.$i18n.t('detailClient.informations.enseigne', { enseigne: this.client.tiersParent.nomCommercial });
      } else if (this.client.typologie === this.typoEnseigne && this.client.tiersParent) {
        nom = this.$i18n.t('detailClient.informations.groupe', { groupe: this.client.tiersParent.nomCommercial });
      }
      return nom;
    },
    aAdressePostale() {
      return !!this.client.adressePostale && !!this.client.adressePostale.ville;
    },
    aAdresseFacturation() {
      if (this.client.adresseFacturationDifferente) {
        return !!this.client.adresseFacturation && this.client.adresseFacturation.ville;
      }
      return this.aAdressePostale;
    },
    libelleTypeMandat() {
      return clientConf.LISTE_TYPE_MANDAT.find(t => t.code === this.client.typeMandatSepa)?.libelle;
    },
    clientTags() {
      return this.client?.tags?.map(t => t.tag) ?? [];
    },
  },
  methods: {
    updateIconMarker(logo) {
      this.iconMarker = null;
      if (!this.client.adressePostale.latitude || !this.client.adressePostale.longitude) return;
      if (logo) {
        const img = document.createElement('img');
        img.onload = () => {
          const dataUrl = getDataUrl(img);
          this.iconMarker = {
            url: dataUrl,
            scaledSize: new google.maps.Size(WIDTH_LOGO_ICON, HEIGHT_LOGO_ICON),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(WIDTH_LOGO_ICON / 2, HEIGHT_LOGO_ICON),
          };
        };
        img.setAttribute('src', logo);
        img.setAttribute('crossOrigin', 'Anonymous');
      } else this.iconMarker = this.markers[0].icon;
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Clients.mapActions({
      actionsLoadClients: 'loadClients',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getMarques() {
      return this.client.tiersMarques.map(m => m.marque.libelle).join(', ');
    },
    getApplicationTvaTrad(value) {
      const find = clientConf.LISTE_APPLICATION_TVA.find((app) => app.code === value);
      return find ? this.$t(find.libelle) : '';
    },
    chunkArray(array, size) {
      return Array.from(
        { length: Math.ceil(array.length / size) },
        (_, index) => array.slice(index * size, (index + 1) * size),
      );
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.client = this.tiersInformation;
      await this.loadParametreUtilisateur();
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.secteurActivite,
        typesParametres.PARAMETRES_KEYS.civilite,
        typesParametres.PARAMETRES_KEYS.typeContact]);
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleFactor.key,
      ]);
      this.utilisateurs = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur);
      await this.setAttachmentContext({ module: 'Client' });
      await this.setAttachmentElementId({ id: this.tiersId });
      const logo = await getLogoClient(this.client);
      this.updateIconMarker(logo);
      const responseContacts = await getAllByTiers(this.client.id);
      this.client.contacts = responseContacts.data.result.items;
      if (this.client.secteurActiviteId && this.client.secteurActiviteId !== undefined) {
        this.secteurActivite = this.secteursActivites.find((secteur) => {
          return this.client.secteurActiviteId === secteur.id;
        }).libelle;
      }
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>
</style>
